import { Route } from 'react-router';

import { adminGuard } from 'modules/auth';
import { withGuard } from '../containers';

const AdminRoute = ({ component, path, exact, children }) => {
  const render = (props) => withGuard(component, adminGuard)({ ...props, children });

  return <Route exact={exact} path={path} render={render} />;
};

export default AdminRoute;
